import { UserPreferences } from '../models/user-preferences';
import { actionsFactory, props } from '@ngneat/effects';

const userPreferencesActions = actionsFactory('user-preferences');

export const saveUserPreferences = userPreferencesActions.create(
  'Save User Preferences',
  props<{ preferences: Partial<UserPreferences> }>()
);
